<div class="row bg-primary p-2 d-flex align-items-center footer-container row-gap-3 fixed-bottom">
  <div class="col-12 col-sm-3 col-md-3 col-lg-3 text-center">
    <p class="m-0 text-white">
      <span class="bi-c-circle"></span>
      2024 DocEstate GmbH
    </p>
  </div>
  <div class="col-12 col-sm-3 col-md-3 col-lg-3 text-center">
    <p class="m-0 text-white">
      <span class="is-clickable" (click)="NavigationUtils.openExternUrl('https://www.docestate.com/agb/')">AGB</span>
    </p>
  </div>
  <div class="col-12 col-sm-3 col-md-3 col-lg-3 text-center">
    <p class="m-0 text-white">
      <span class="is-clickable"
            (click)="NavigationUtils.openExternUrl('https://www.docestate.com/datenschutzerklaerung/')">Datenschutz</span>
    </p>
  </div>
  <div class="col-12 col-sm-3 col-md-3 col-lg-3 text-center">
    <p class="m-0 text-white">
      <span class="is-clickable" (click)="NavigationUtils.openExternUrl('https://www.docestate.com/impressum/')">Impressum</span>
    </p>
  </div>
</div>
